module.exports = __webpack_public_path__ + "static/media/lupa.043a95fc.svg";